module.exports = __webpack_public_path__ + "img/derecho-laboral.80a4d726.svg";